
import { FETCH_ALL_VF_USERS_LIST} from "../actionTypes";
import { fetchAllVFusersList } from "../../../api/userManagement/getAllVFusersList.service";


const requestListRequest = ()=>({type: FETCH_ALL_VF_USERS_LIST.REQUEST})
const requestListFailure = (error)=>({type: FETCH_ALL_VF_USERS_LIST.FAILURE, error})
const requestListSuccess = (obj)=>({type: FETCH_ALL_VF_USERS_LIST.SUCCESS, obj})

export const getAllVFusersList = (next=null)=>{
    return (dispatch, getState)=>{        
        dispatch(requestListRequest()) 
        return fetchAllVFusersList(next)  
        .then((res) => {
            const obj={
                "data" : res?.rights
            }
            dispatch(requestListSuccess(obj));
            return Promise.resolve(true)
          })
        .catch(error => {
            dispatch(requestListFailure(error?.message))
            return Promise.resolve(false)
        })
    }
}